import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService, httpOptions } from '@core/service/base.service';
import { Observable } from 'rxjs/index';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompactService extends BaseService {
  private url = 'api/compact-base';

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl() {
    return this.url;
  }


  /**
   * 获取workflowId
   */
  //getWorkflowId():Observable<any> {
  //  const url = this.getUrl()+"/workflowId";
  //  return this.http.get<any>(url).pipe(
  //    tap(_ => this.log("Get workflowId")),
  //    catchError(this.handleError<any>("Get workflowId"))
  //  );
  //}
  findFatDto(id: number): Observable<any> {
    console.log('进入请求函数');
    const url = this.getUrl() + '/findFatDto/' + id;
    return this.http.get<any>(url);
  }

  commitToOa(compactBase: any): Observable<any> {
    const url = `${this.getUrl()}/commit`;
    return this.http.post<any>(url, compactBase, httpOptions).pipe(
      tap(_ => this.log('commit')),
      catchError(this.handleError<any>('commit')),
    );
  }

  batchDelete(ids: any[]): Observable<any> {
    const url = `${this.getUrl()}/batch/delete`;
    return this.http.post<any>(url, ids).pipe(
      tap(_ => this.log(`/batch/delete`)),
      catchError(this.handleError<any>(`/batch/delete`)),
    );
  }

  batchSendSmsToSupllier(ids: any[]): Observable<any> {
    const url = `${this.getUrl()}/batch-send`;
    return this.http.post<any>(url, ids).pipe(
      tap(_ => this.log(`/batch-send`)),
      catchError(this.handleError<any>(`/batch-send`)),
    );
  }

  downFile(data: any): Observable<any> {
    console.log('进入请求函数');
    const url = this.getUrl() + '/down-file';
    return this.http.post<any>(url, data).pipe(
      tap(_ => this.log(`/down-file`)),
      catchError(this.handleError<any>(`/down-file`)),
    );
  }
  findByCompactCode(code: any) : Observable<any> {
    const url = this.getUrl() +'/findOneByCompactCode';
    return this.http.post<any>(url, code, httpOptions).pipe(
      tap(_ => this.log(`findOneByCompactCode`)),
      catchError(this.handleError<any>('查询出错'))
    );
  }
}
